import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgPrint = ({ className, ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('svg', 'svg-print', className)}
    {...props}>
    <path
      d="M17.7475 8.32932C17.4713 8.32932 17.2475 8.10546 17.2475 7.82932C17.2475 7.55317 17.4713 7.32932 17.7475 7.32932H19.4952C19.7714 7.32932 19.9952 7.10546 19.9952 6.82932V1.5C19.9952 1.22386 19.7714 1 19.4952 1H1.5C1.22386 1 1 1.22386 1 1.5V6.82932C1 7.10546 1.22386 7.32932 1.5 7.32932H3.31914C3.59528 7.32932 3.81914 7.55317 3.81914 7.82932C3.81914 8.10546 3.59528 8.32932 3.31914 8.32932H1.5C0.671573 8.32932 0 7.65774 0 6.82932V1.5C0 0.671573 0.671573 0 1.5 0H19.4952C20.3237 0 20.9952 0.671573 20.9952 1.5V6.82932C20.9952 7.65774 20.3237 8.32932 19.4952 8.32932H17.7475Z"
      transform="translate(1.5 9.91905)"
    />
    <path
      d="M10.5762 5.91595C10.5762 6.19088 10.7982 6.41424 11.0731 6.41594C11.3504 6.41765 11.5762 6.1933 11.5762 5.91595V2.56042L9.57931 0L1 0C0.447715 0 0 0.447715 0 1L0 5.85054C0 6.12547 0.221974 6.34882 0.496899 6.35052C0.774239 6.35224 0.999982 6.12789 0.999983 5.85054L1 1H9.09105L10.5762 2.90427V5.91595Z"
      transform="translate(6.20947 2)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.32788 0C1.6189 0 1.00659 0.49651 0.860352 1.1903L0.0322266 5.11411C0.0107422 5.21594 0 5.31973 0 5.42381C0 6.25224 0.671631 6.92381 1.5 6.92381H10.6101C10.7141 6.92381 10.8179 6.91298 10.9199 6.89149C11.7305 6.72045 12.2488 5.92469 12.0779 5.11411L11.2498 1.1903C11.1035 0.49651 10.4912 0 9.78223 0H2.32788ZM1.5 5.92381C1.22388 5.92381 1 5.69995 1 5.42381C1 5.38912 1.00366 5.35452 1.01074 5.32058L1.83887 1.39677C1.88745 1.1655 2.09155 1 2.32788 1H9.78223C10.0186 1 10.2227 1.1655 10.2715 1.39677L11.0994 5.32058C11.1562 5.59077 10.9836 5.85602 10.7134 5.91304C10.6794 5.9202 10.6448 5.92381 10.6101 5.92381H1.5Z"
      transform="translate(5.94263 14.3262)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 1.5C1.16421 1.5 1.5 1.16421 1.5 0.75C1.5 0.335786 1.16421 0 0.75 0C0.335786 0 0 0.335786 0 0.75C0 1.16421 0.335786 1.5 0.75 1.5Z"
      transform="translate(18 12)"
    />
  </svg>
);

SvgPrint.propTypes = {
  className: PropTypes.string,
};

export default SvgPrint;
